import React from "react";

export default function PageHeader({ eyebrow, title, accent, sub, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
      <div>
        {eyebrow && <div className="text-[11px] tracking-[.3em] uppercase text-amber-400/80">{eyebrow}</div>}
        <h1 className="text-3xl md:text-4xl font-light mt-2">{title} {accent && <span className="text-amber-400">{accent}</span>}</h1>
        {sub && <p className="text-sm text-zinc-500 mt-2">{sub}</p>}
      </div>
      <div className="flex flex-wrap items-center gap-2">{children}</div>
    </div>
  );
}

export const Stat = ({ label, value, sub, color = "text-white", icon: I }) => (
  <div className="rounded-xl border border-white/10 bg-[#111215] p-5 hover:border-amber-400/30 transition-colors">
    <div className="flex items-center justify-between text-xs text-zinc-500">{label}{I && <I className="w-4 h-4 text-zinc-600" />}</div>
    <div className={`text-2xl font-light mt-2 ${color}`}>{value}</div>
    {sub && <div className="text-[11px] text-zinc-500 mt-1">{sub}</div>}
  </div>
);

export const btnPrimary = "h-10 px-4 rounded-lg bg-amber-400 hover:bg-amber-300 text-zinc-900 text-sm font-medium flex items-center gap-2 transition-colors";
export const btnGhost = "h-10 px-4 rounded-lg border border-white/10 hover:bg-white/5 text-sm flex items-center gap-2 transition-colors";
export const field = "bg-[#16181b] border-white/10 focus-visible:ring-amber-400/60";
